export const overrides = {
    MuiChip: {
        root: {
            height: '24px'
        }
    }
};
